document.addEventListener('DOMContentLoaded', function() {

  // Open Complianz cookie settings (if Complianz enabled)
  document.getElementById('cookie-settings')?.addEventListener('click', function(e) {
    e.preventDefault();

    document.querySelectorAll('.cmplz-manage-consent').forEach(function(obj) {
      obj.click();
    });
  });

  // Open Service Form cookie settings 
  document.getElementById('cookie-settings')?.addEventListener('click', function(e) {
    e.preventDefault();
    sf_cc.openModal()
  });

});
